import { createSvg } from '@r1-frontend/ui-kit/atoms/svg/createSvg';

const Settings = (
    {
        strokeWidth = 1.8,
    },
): JSX.Element => {
    return (
        <g id={'guts'}>
            <path
                d='M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M15.5693 18.4996V14.5996'
                strokeWidth={strokeWidth}
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M15.5693 7.45V5.5'
                strokeWidth={strokeWidth}
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M15.5707 12.6492C17.0066 12.6492 18.1707 11.4852 18.1707 10.0492C18.1707 8.61328 17.0066 7.44922 15.5707
                 7.44922C14.1348 7.44922 12.9707 8.61328 12.9707 10.0492C12.9707 11.4852 14.1348 12.6492 15.5707 12.6492Z'
                strokeWidth={strokeWidth}
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M8.43066 18.5008V16.5508'
                strokeWidth={strokeWidth}
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M8.43066 9.4V5.5'
                strokeWidth={strokeWidth}
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M8.43008 16.5496C9.86602 16.5496 11.0301 15.3855 11.0301 13.9496C11.0301 12.5137 9.86602 11.3496 8.43008
                 11.3496C6.99414 11.3496 5.83008 12.5137 5.83008 13.9496C5.83008 15.3855 6.99414 16.5496 8.43008 16.5496Z'
                strokeWidth={strokeWidth}
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </g>
    );
};

export default createSvg(
    Settings,
    'settings',
);

